import styled from "styled-components";

const DefaultInputHoverBorderColor      = '#002b70';
const DefaultInputBorderColor           = '#CCCCCC';
const DefaultInputWidth                 = '100%';
//const DefaultInputFontSize              = '0.8em';
const DefaultInputFontSize              = '11px';
const DefaultInputHeaderFontSize        = '0.8em';

const DefaultFontFamily                 = "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen'," +
                                            "'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue'," +
                                            "sans-serif";
const DefaultMaxScreenSize              = "575px";
const DefaultTableTextValueSize         = "11px";
const DefaultTablBodyFontSize           = "10px";
const ButtonBgColorMode     = {
    default: '#DDDDDD',
    primary: '#193498',
    success: '#7ECA9C',
    warning: 'orange',
    danger: '#FA4659',
    active: '#1597BB',
    inactive: '#BBBBBB'
}

const HandleInputTextColorMode = Mode => {
    if (typeof Mode !== 'undefined') {
        switch(Mode.toString().toLowerCase()) {
            case "normal":
                return '#3D84B8';
            case "primary":
                return '#002b70';
            case "warning":
                return "darkorange";
            case "danger":
                return 'red';
            case "error":
                return '#F05454';
            case "success":
                return 'green';
            case "subject":
                return '#3c8dbc';
            case "information":
                return 'dimgrey';
            case "active":
                return '#22577A';
            case "inactive":
                return '#345B63';
            case "online":
                return '#4CA1A3';
            default:
                return '#000000';
        }
    } else {
        return '#000000';
    }    
}

const HandleTextColorMode = Mode => {
    if (typeof Mode !== 'undefined') {
        switch(Mode.toString().toLowerCase()) {
            case "normal":
                return '#3D84B8';
            case "primary":
                return '#002b70';
            case "warning":
                return "darkorange";
            case "danger":
                return 'red';
            case "error":
                return '#F05454';
            case "success":
                return 'green';
            case "subject":
                return '#3c8dbc';
            case "information":
                return 'dimgrey';
            case "active":
                return '#22577A';
            case "inactive":
                return '#345B63';
            case "online":
                return '#4CA1A3';
            case 'preview':
                return '#F05945';
            default:
                return 'darkgrey';
        }
    } else {
        return 'darkgrey';
    }    
}

const handleBoxModeBgColor   = Mode => {
    if (typeof Mode !== "undefined") {
        switch(Mode.toString().toLowerCase()) {
        case 'normal':
            return 'dimgrey';
        case 'primary':
            return '#002b70';
        case 'success':
            return 'darkgreen';
        case 'warning':
            return 'darkorange';
        case 'danger':
            return 'red';
        case 'active':
            return '#1597BB';
        case 'inactive':
            return '#BBBBBB';
        case 'preview':
            return '#F05945';
        default:
            return '#DDDDDD';
        }
    } else {
        return '#DDDDDD';
    }
}

const handleBoxModeBacklightColor   = Mode => {
    if (typeof Mode !== "undefined") {
        switch(Mode.toString().toLowerCase()) {
        case 'normal':
            return '0px 4px 14px -3px dimgrey';
        case 'primary':
            return '0px 4px 14px -3px #002b70';
        case 'success':
            return '0px 4px 14px -3px #B5CDA3';
        case 'warning':
            return '0px 4px 14px -3px #F3C583';
        case 'danger':
            return '0px 4px 14px -3px #E99497';
        case 'active':
            return '0px 4px 14px -3px #1597BB';
        case 'inactive':
            return '0px 4px 14px -3px #BBBBBB';
        case 'preview':
            return '0px 4px 14px -3px #F05945';
        default:
            return 'none';
        }
    } else {
        return 'none';
    }
}

const handleTitleModeBgColor   = Mode => {
    if (typeof Mode !== "undefined") {
        switch(Mode.toString().toLowerCase()) {
        case 'normal':
            return 'dimgrey';
        case 'primary':
            return '#002b70';
        case 'success':
            return 'darkgreen';
        case 'warning':
            return 'darkorange';
        case 'danger':
            return 'red';
        case 'active':
            return '#1597BB';
        case 'inactive':
            return '#BBBBBB';
        default:
            return '#002b70';
        }
    } else {
        return '#002b70';
    }
}

const handleButtonModeBgColor   = Mode => {
    if (typeof Mode !== "undefined") {
        switch(Mode.toString().toLowerCase()) {
        case 'primary':
            return '#193498';
        case 'success':
            //return '#7ECA9C';
            return 'darkgreen';
        case 'warning':
            //return 'orange';
            return 'darkorange';
        case 'danger':
            return '#FA4659';
        case 'active':
            return '#1597BB';
        case 'inactive':
            return '#BBBBBB';
        case 'none':
            return 'transparent';
        case 'normal':
            return '#3D84B8';
        default:
            return '#DDDDDD';
        }
    } else {
        return '#DDDDDD';
    }
}
const handleButtonModeBgHover   = Mode => {
    if (typeof Mode !== "undefined") {
        switch(Mode.toString().toLowerCase()) {
        case 'primary':
            return '#1597E5';
        case 'success':
            //return '#A5E1AD';
            return '#7ECA9C';
        case 'warning':
            //return '#FFC947';
            return 'orange';
        case 'danger':
            return '#F34573';
        case 'active':
            return '#1CB3C8';
        case 'inactive':
            return '#DFE2E2';
        case 'none':
            return 'unset';
        default:
            //return '#DFE2E2';
            return 'dimgrey';
        }
    } else {
        //return '#DFE2E2';
        return 'dimgrey';
    }
}
const handleButtonModeBoxShadow     = Mode => {
    if (typeof Mode !== "undefined") {
        switch(Mode.toString().toLowerCase()) {
        case 'primary':
            //return '#1597E5';
            return 'lightgrey'
        case 'success':
            return '#A5E1AD';
        case 'warning':
            return '#FFC947';
        case 'danger':
            return '#F34573';
        case 'active':
            return '#1CB3C8';
        case 'inactive':
            return '#DFE2E2';
        default:
            return 'none';
        }
    } else {
        return 'none';
    }
}
const handleButtonModeText   = Mode => {
    if (typeof Mode !== "undefined") {
        switch(Mode.toString().toLowerCase()) {
        case 'primary':
            return '#FFFFFF';
        case 'success':
            return 'green';
        case 'warning':
            return '#FFFFFF';
        case 'danger':
            return '#FFFFFF';
        case 'active':
            return '#FFFFFF';
        case 'inactive':
            return 'dimgrey';
        default:
            return '#DDDDDD';
        }
    } else {
        return '#DDDDDD';
    }
}
const DefaultInputBoxWidth              = "80%";

const handleControlleColorMode      = Mode => {
    if (typeof Mode !== "undefined") {
        switch(Mode.toString().toLowerCase()) {
        case 'primary':
            return '#002b70';
        case 'success':
            return 'darkgreen';
        case 'warning':
            return '#FFBF86';
        case 'danger':
            return 'red';
        default:
            return 'lightgrey';
        }
    } else {
        return 'lightgrey';
    }
}

const handleControlleColorHoverMode      = Mode => {
    if (typeof Mode !== "undefined") {
        switch(Mode.toString().toLowerCase()) {
        case 'primary':
            return '#3c8dbc';
        case 'success':
            return '#B5CDA3';
        case 'warning':
            return '#FFBF86';
        case 'danger':
            return '#FF5C58';
        default:
            return 'dimgrey';
        }
    } else {
        return 'dimgrey';
    }
}

const BtnBacklightColorMode         = {
    default: '#3c8dbc',
    primary: '#3c8dbc',
    success: '#B5CDA3',
    warning: '#FFBF86',
    danger: 'red',
}

const BtnTextColorMode      = {
    default: '#002b70',
    primary: '#002b70',
    success: 'green',
    warning: 'darkorange',
    danger: 'red',
}

const BtnBgHoverColorMode   = {
    default: '#3c8dbc',
    primary: '#3c8dbc',
    success: 'darkgreen',
    warning: 'darkorange',
    danger: 'red',
}

// =======================================================
// INPUT CONTAINER
// =======================================================
export const InputPageContainer     = styled.div`
    //width: 100%;
    width: ${({IsJustify}) => (
        IsJustify?
        '99%':'100%'
    )};
    background-color: transparent;
    //background-color: pink;

    display: flex;
    //justify-content: center;
    justify-content: ${({IsJustify}) => (
        IsJustify?
        'space-between':'center'
    )};
    margin-top: 5px;
    margin-right: ${({IsJustify}) => (
        IsJustify?
        '10px':undefined
    )};
    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        //flex-direction: column;
        margin-right: ${({IsJustify}) => (
            IsJustify?
            'unset': undefined
        )};
        
        flex-direction: ${({IsJustify}) => (
            IsJustify?
            'column':'unset'
        )};
        
        //align-items: center;
        align-items: ${({IsJustify}) => (
            IsJustify?
            'center': undefined
        )};
        transition: 0.3s ease-in-out;
    }
`;
export const InputBoxContainer      = styled.div`
    display: flex;
    background-color: transparent;
    width: ${({Width}) => (
        typeof Width === 'number' && Width >= 0 && Width <= 100?
        `${Width}%`: DefaultInputBoxWidth
    )};
    margin: 0;
    justify-content: center;
    margin-bottom: 5px;

    height: ${({IsFixHeight}) => (
        IsFixHeight?
        'max-content':undefined
    )};

    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        //width: 97%;
        //&:first-child {
        //    margin-bottom: 5px;
        //}        
        width: 98%;
        transition: 0.3s ease-in-out;
    }
`;
export const InputBox               = styled.div`
    width: 100%;
    display: flex;
    
    flex-direction: column;

    background-color: white;
    border-radius: 5px;

    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    padding-bottom: 10px;

    border: solid 1px ${({ Mode }) => handleBoxModeBgColor(Mode)};
    box-shadow: ${({ Mode }) => handleBoxModeBacklightColor(Mode)};
`;
// -----------------
// HEADER
// -----------------
export const InputBoxHeader         = styled.div`
    width: 100%;
    display: flex; 
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;

    top: 0;
    bottom: auto;

    background-color: transparent;
    padding-bottom: 5px;
    border-bottom: solid 0.5px lightgrey;
`;

export const InputBoxHeaderTitle    = styled.div`
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-items: center;

    font-size: ${({FontSize}) => (
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        DefaultInputHeaderFontSize:`${FontSize}`
    )};    
    color: ${({ Mode }) => handleTitleModeBgColor(Mode)};
    font-weight: bold;
    text-transform: uppercase;
    padding-top: 10px;
`;

export const InputBoxHeaderController   = styled.div`
    display: flex;
`;
export const InputBoxHeaderBtn          = styled.div.attrs(({ IsBtnClose }) => ({
    title:  IsBtnClose? 'Click to close': undefined
  }))`
    color: ${({ Mode }) => handleControlleColorMode(Mode)};
    //color: lightgrey;
    &:hover {
        //color: dimgrey;
        color: ${({ Mode }) => handleControlleColorHoverMode(Mode)};
    }
    cursor: pointer;
`;
export const InputBoxHeaderBtnFull      = styled.button.attrs(({ IsSubmitButton }) => ({
    type:  IsSubmitButton? 'submit':'button'
  }))`
    width: ${({Width}) => (
        typeof Width === 'number' && Width > 0?
        `${Width}px`: '70px'
    )};
    font-size: ${({FontSize}) => (
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        '9px':`${FontSize}`
    )};
    background-color: #FFFFFF;
    color: ${({Mode}) => (
        typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
        BtnTextColorMode.default
        :`${Mode}`.trim().toLowerCase() === 'primary'?
        BtnTextColorMode.primary
        :`${Mode}`.trim().toLowerCase() === 'success'?
        BtnTextColorMode.success
        :`${Mode}`.trim().toLowerCase() === 'warning'?
        BtnTextColorMode.warning
        :BtnTextColorMode.default
    )};
    border: solid 0.8px ${({Mode}) => (
        typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
        //BtnTextColorMode.default
        'lightgrey'
        :`${Mode}`.trim().toLowerCase() === 'primary'?
        //BtnTextColorMode.primary
        'lightgrey'
        :`${Mode}`.trim().toLowerCase() === 'success'?
        BtnTextColorMode.success
        :`${Mode}`.trim().toLowerCase() === 'warning'?
        BtnTextColorMode.warning            
        :'lightgrey'
    )};

    font-weight: bold;
    cursor: pointer;

    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    
    align-items: center;

    padding-top: 4px;
    padding-bottom: 4px;
    padding-right: 5px;
    padding-left: 5px;
    
    border-radius: 5px;

    &:hover {
        color: #FFFFFF;
        background-color: ${({Mode}) => (
            typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
            BtnBgHoverColorMode.default
            :`${Mode}`.trim().toLowerCase() === 'primary'?
            BtnBgHoverColorMode.primary
            :`${Mode}`.trim().toLowerCase() === 'success'?
            BtnBgHoverColorMode.success
            :`${Mode}`.trim().toLowerCase() === 'warning'?
            BtnBgHoverColorMode.warning
            :BtnBgHoverColorMode.default
        )};
        border: solid 0.8px ${({Mode}) => (
            typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
            BtnBgHoverColorMode.default
            :`${Mode}`.trim().toLowerCase() === 'primary'?
            BtnBgHoverColorMode.primary
            :`${Mode}`.trim().toLowerCase() === 'success'?
            BtnBgHoverColorMode.success
            :`${Mode}`.trim().toLowerCase() === 'warning'?
            BtnBgHoverColorMode.warning
            :BtnBgHoverColorMode.default
        )};

        box-shadow: 0px 4px 14px -3px ${({Mode}) => (
            typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
            BtnBacklightColorMode.default
            :`${Mode}`.trim().toLowerCase() === 'primary'?
            BtnBacklightColorMode.primary
            :`${Mode}`.trim().toLowerCase() === 'success'?
            BtnBacklightColorMode.success
            :`${Mode}`.trim().toLowerCase() === 'warning'?
            BtnBacklightColorMode.warning
            :BtnBacklightColorMode.default
        )};
    }
`;

// -----------------
// BODY
// -----------------
export const InputBoxBody               = styled.div`
    background-color: transparent;

    display: flex;
    flex-direction: column;
    width: 100%;    

    overflow: hidden;
`;
    export const BoxMapContainer        = styled.div`
        margin-top: 5px;
        width: 100%;
        display: flexbox;
        background-color: transparent; 

        padding-bottom: 5px;
        border-bottom: solid 0.4px lightgrey;
    `;

    export const BoxMap                 = styled.div`
        width: 100%;
        display: flexbox;
        background-color: transparent; 
        height: ${({Height}) => (
            typeof Height === 'number' && Height >= 0?
            `${Height}px`: '300px'
        )};
    `;
    export const BoxMapError            = styled.div`
        background-color: whitesmoke;

        width: 100%;
        height: 100%;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        justify-content: center;
    `;
    export const BoxMapErrorIcon        = styled.div`
        color: red;
    `;
    export const BoxMapErrorText        = styled.div`
        font-size: 0.9em;
    `;

    export const BoxInput               = styled.div`
        background-color: transparent;
        width: 50%;
    `;
// -----------------
// FOOTER
// -----------------
export const InputBoxFooter             = styled.div`
    margin-top: ${({MarginTop}) => (
        typeof MarginTop === 'number' && MarginTop > 0?
        `${MarginTop}px`: '5px'
    )};
    padding-top: 3px;
    padding-bottom: 3px;
    /* width: 100%; */
    width: ${({Width}) => (
        typeof Width === 'number' && Width > 0?
        `${Width}%`: DefaultInputWidth
    )};
    display: flex;
    align-items: center;
    flex-direction: row;
    background-color: transparent;
`;

export const InputMessage               = styled.div`
    margin-left: ${({MarginLeft}) => (
        typeof MarginLeft === 'number' && MarginLeft > 0?
        `${MarginLeft}px`: 'unset'
    )};
    color: red;
    font-size: ${({FontSize}) => (
        typeof FontSize === 'undefined' || `${FontSize}`.trim() === '' ?
        DefaultInputFontSize:`${FontSize}`
    )};
`;
// =======================================================
// INPUT TEXT
// =======================================================
export const InputPickerContainer = styled.div`
    margin-top: ${({MarginTop}) => (
        typeof MarginTop === 'number' && MarginTop > 0?
        `${MarginTop}px`: 'unset'
    )};
    width: ${({Width}) => (
        typeof Width === 'number' && Width > 0?
        `${Width}%`: DefaultInputWidth
    )};

    background-color: pink;

    display: flex;
    padding: 5px 3px;
    background-color: white;
    border: none;


    font-size: ${({FontSize}) => (
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        DefaultInputFontSize:`${FontSize}`
    )};

    box-sizing: border-box;
    box-shadow: ${({IsBoxed}) => (
        IsBoxed?
        '0px 2px 2px #CCCCCC':'unset'
    )};
    outline: none;
    
    border: 0.5px solid ${(DefaultInputBorderColor)};
    border-radius: 2px;

    overflow: hidden;

    &:hover {
        border: 0.5px solid ${(DefaultInputHoverBorderColor)};
        box-shadow: ${({IsBoxed}) => (
            IsBoxed?
            '0px 2px 2px #CCCCCC':'unset'
        )};
    }
    &:focus {
        border: 0.5px solid ${(DefaultInputHoverBorderColor)};
        //box-shadow: unset;
        box-shadow: ${({IsBoxed}) => (
            IsBoxed?
            '0px 2px 2px #CCCCCC':'unset'
            //`0px 2px 2px ${DefaultInputHoverBorderColor}`:'unset'
        )};
    }    
    
    @media only screen and (max-width: ${(DefaultMaxScreenSize)}) {
        width: 100%;
        font-size: calc(75%);
        transition: 0.3s ease-in-out;
    }
`;

export const InputSelect    = styled.select`
    width: ${({Width}) => (
        typeof Width === 'number' && Width > 0?
        `${Width}%`: DefaultInputWidth
    )};
    font-size: ${({FontSize}) => (
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        DefaultInputFontSize:`${FontSize}`
    )};
    background-color: white;
    display: inline-block;
    padding: 5px 3px;

    border: 0.5px solid ${(DefaultInputBorderColor)};
    //border-radius: 5px;
    border-radius: 2px;
    box-sizing: border-box;
    //box-shadow: none;
    box-shadow: ${({IsBoxed}) => (
        IsBoxed?
        '0px 2px 2px #CCCCCC':'unset'
    )};
    
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    -o-appearance: none;
    appearance: none;

    &:hover {
        border: 0.5px solid ${(DefaultInputHoverBorderColor)};
        box-shadow: ${({IsBoxed}) => (
            IsBoxed?
            '0px 2px 2px #CCCCCC':'unset'
        )};
    }
    &:focus {
        border: 0.5px solid ${(DefaultInputHoverBorderColor)};
        //box-shadow: none;
        box-shadow: ${({IsBoxed}) => (
            IsBoxed?
            '0px 2px 2px #CCCCCC':'unset'
        )};
    }

    @media only screen and (max-width: ${(DefaultMaxScreenSize)}) {
        //width: 100%;
        font-size: calc(80%);
        width: ${({IsFixWidth, Width}) => (
            IsFixWidth?
            Width:'100%'
        )};

        transition: 0.3s ease-in-out;
    }
`;

export const InputTextArea      = styled.textarea`
    width: ${({Width}) => (
        typeof Width === 'number' && Width > 0?
        `${Width}%`: DefaultInputWidth
    )};
    font-size: ${({FontSize}) => (
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        DefaultInputFontSize:`${FontSize}`
    )};
    font-weight: ${({IsBold}) => (
        IsBold?
        'bold':'normal'
    )}; 
    display: inline-flex;
    font-family: ${(DefaultFontFamily)};
    padding: 5px 3px;

    resize: none;    
    border: solid 0.5px #ccc;
    border-radius: 2px;
    box-sizing: border-box;
    //box-shadow: none;
    box-shadow: ${({IsBoxed}) => (
        IsBoxed?
        '0px 2px 2px #CCCCCC':'unset'
    )};

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    cursor: default;

    &:hover {
        border: 0.5px solid ${(DefaultInputHoverBorderColor)};
    }
    &:focus {
        border: 0.5px solid ${(DefaultInputHoverBorderColor)};
        box-shadow: none;
    }

    @media only screen and (max-width: ${(DefaultMaxScreenSize)}) {
        //width: 100%;
        font-size: calc(85%);
        width: ${({IsFixWidth, Width}) => (
            IsFixWidth?
            Width:'100%'
        )};
        //font-size: larger;
        display: flexbox;
        transition: 0.3s ease-in-out;
    }
`;

export const InputText      = styled.input.attrs(({ IsPassword }) => ({
    type:  IsPassword? 'password':'text'
  }))`
    width: ${({Width}) => (
        typeof Width === 'number' && Width > 0?
        `${Width}%`:DefaultInputWidth
    )};    

    font-size: ${({FontSize}) => (
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        DefaultInputFontSize:`${FontSize}`
    )};

    text-transform: ${({IsUpperCase}) => (
        IsUpperCase?
        'uppercase':'normal'
    )};
    //display: inline-flex;
    color: ${({ Color }) => HandleInputTextColorMode(Color)};
    display: inline-block;
    padding: 5px 3px;
    background-color: white;

    box-sizing: border-box;
    box-shadow: ${({IsBoxed}) => (
        IsBoxed?
        '0px 2px 2px #CCCCCC':'unset'
    )};
    outline: none;
    
    border: 0.5px solid ${(DefaultInputBorderColor)};
    border-radius: 2px;
    
    &[type=password] {
        //box-shadow: unset;
        box-sizing: border-box;
        box-shadow: ${({IsBoxed}) => (
            IsBoxed?
            '0px 2px 2px #CCCCCC':'unset'
        )};
        border-radius: 2px;
            width: ${({Width}) => (
            typeof Width === 'number' && Width > 0?
            `${Width}%`:DefaultInputWidth
        )};
    }

    cursor: ${({readOnly}) => (
        readOnly?
        'unset':'text'
    )};

    &:hover {
        border: 0.5px solid ${(DefaultInputHoverBorderColor)};
        box-shadow: ${({IsBoxed}) => (
            IsBoxed?
            '0px 2px 2px #CCCCCC':'unset'
        )};
    }
    &:focus {
        border: 0.5px solid ${(DefaultInputHoverBorderColor)};
        //box-shadow: unset;
        box-shadow: ${({IsBoxed}) => (
            IsBoxed?
            '0px 2px 2px #CCCCCC':'unset'
            //`0px 2px 2px ${DefaultInputHoverBorderColor}`:'unset'
        )};
    }    
    

    @media only screen and (max-width: ${(DefaultMaxScreenSize)}) {   
        //font-size: calc(88%);
        display: inline-flex;
        font-size: calc(85%);
        width: ${({IsFixWidth, Width}) => (
            IsFixWidth?
            Width:'100%'
        )};
        &[type=password] {
            width: ${({IsFixWidth, Width}) => (
                IsFixWidth?
                Width:'100%'
            )};
        }
        transition: 0.3s ease-in-out;
    }
`;

// =======================================================
// LABEL
// =======================================================
export const LabelContainer     = styled.div`
    background-color: transparent;
    display: flex;
    //align-items: center;
    justify-items: center;
    //align-items: flex-start;
    font-size: ${({FontSize}) => (
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        'unset':`${FontSize}`
    )};   
    margin-top: ${({MarginTop}) => (
        typeof MarginTop === 'number' && MarginTop > 0?
        `${MarginTop}px`: 'unset'
    )};
    align-items: ${({VAlign}) => (
        typeof VAlign === 'string' && VAlign.trim() !== ''?
            VAlign.trim().toLowerCase() === 'top'?
            `flex-start`
            :VAlign.trim().toLowerCase() === 'bottom'?
            `flex-end`
            :VAlign.trim().toLowerCase() === 'middle' || VAlign.trim().toLowerCase() === 'center'?
            `center`
            :'center'
         :'center'
    )};

    padding-top: ${({VAlign}) => (
        typeof VAlign === 'string' && VAlign.trim() !== ''?
            VAlign.trim().toLowerCase() === 'top'?'1px':'unset'
         :'unset'
    )};
    padding-bottom: ${({VAlign}) => (
        typeof VAlign === 'string' && VAlign.trim() !== ''?
            VAlign.trim().toLowerCase() === 'bottom'? '1px':'unset'
         :'unset'
    )};

    width: ${({Width}) => (
        typeof Width === 'number' && Width > 0?
        `${Width}%`: '26%'
    )};
    overflow: ${({IsOverflowHidden}) => (
        IsOverflowHidden?
        'hidden': 'unset'
    )};
    @media only screen and (max-width: ${(DefaultMaxScreenSize)}) {
        //width: 100%;
        width: ${({IsFixWidth, Width}) => (
            IsFixWidth?
            Width:'100%'
        )};
        margin-bottom: ${({IsFixWidth}) => (
            IsFixWidth?
            '5px':'unset'
        )};
        transition: 0.3s ease-in-out;
    }
`;
export const InputLabel = styled.label`
    //width: 100%;
    width: ${({Width}) => (
        typeof Width === 'number' && Width > 0?
        `${Width}%`: DefaultInputWidth
    )};
    //font-size: 0.8em;
    font-size: ${({FontSize}) => (
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        DefaultInputFontSize:`${FontSize}`
    )};   
    font-weight: ${({IsBold}) => (
        IsBold?
        'bold':'normal'
    )};  
    
    display: flow-root;
    padding: 5px 3px;
    
    text-align: ${({IsCentered}) => (
        IsCentered?
        'center': 'left'
    )};   

    color: ${({Color}) => (
        typeof Color === 'string' && Color.trim() !== ''?
        `${Color}`: '#000000'
    )};
    background-color: transparent;
    //background-color: pink;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select:none;

    @media only screen and (max-width: ${(DefaultMaxScreenSize)}) {
        font-size: calc(80%);  
        width: 100%;
        transition: 0.3s ease-in-out;
    }
`;
// =======================================================
// ROW INPUT
// =======================================================
export const RowSeparator       = styled.div`    
    margin-top: ${({MarginTop}) => (
        typeof MarginTop === 'number' && MarginTop > 0?
        `${MarginTop}px`: 'unset'
    )};

    margin-bottom: ${({MarginBottom}) => (
        typeof MarginBottom === 'number' && MarginBottom > 0?
        `${MarginBottom}px`: 'unset'
    )};

    width: 100%;
    display: flex;
    flex-direction: row;
    background-color: transparent;    
    padding-bottom: 2px;
    /* border-bottom: solid 0.8px lightgrey; */
    
    border-bottom: ${({NoUnderline}) => (
        NoUnderline?
        'unset':'solid 0.8px lightgrey'
    )}; 

    margin-bottom: 1mm;

    @media only screen and (max-width: ${(DefaultMaxScreenSize)}) {
        //margin-top: 1mm;
        margin-top: ${({MarginTop, IsFixed}) => (
            IsFixed?
            typeof MarginTop === 'number' && MarginTop > 0?
            `${MarginTop}px`: '1mm'
            :
            '1mm'
        )};
        transition: 0.3s ease-in-out;
    }
`;
    export const SeparatorTitle     = styled.div`
        text-transform: ${({IsUpperCase}) => (
            !IsUpperCase?
            'normal':'uppercase'
        )};
        font-size: ${({FontSize}) => (
            typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
            '10px':`${FontSize}`
        )};    
        font-weight: ${({IsBold}) => (
            IsBold?
            'bold':'normal'
        )}; 
        font-style: ${({IsItalic}) => (
            IsItalic?
            'italic':'normal'
        )};
          
        display: flex;
        align-items: center;
        color: dimgray;

        text-align: left;

        -webkit-touch-callout: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select:none;
    `;

export const RowInput           = styled.div`
    margin-top: ${({MarginTop}) => (
        typeof MarginTop === 'number' && MarginTop > 0?
        `${MarginTop}px`: 'unset'
    )};

    width: ${({Width}) => (
        typeof Width === 'number' && Width > 0?
        `${Width}%`: DefaultInputWidth
    )};
    
    display: ${({IsMultiRow}) => (
       !IsMultiRow?
       'flex':'inline-flex'
    )};    
    flex-direction: ${({IsMultiRow}) => (
       !IsMultiRow?
       'row':'column'
    )};
    flex-wrap: nowrap;
    
    justify-content: ${({IsMultiRow}) => (
        IsMultiRow?
       'unset':'space-between'
    )};
    background-color: transparent;
    padding-top: 1px;
    padding-bottom: 1px;

    //overflow: hidden;
    margin-bottom: 1mm;
    &:last-child {
        margin-bottom: unset;
    }
    @media only screen and (max-width: ${(DefaultMaxScreenSize)}) {
        width: 100%;        
        display: ${({IsMultiRow}) => (
            !IsMultiRow?
            'inline-flex'
            :'inline-flex'
        )};
        flex-direction: column;

        transition: 0.3s ease-in-out;
    }
`;

export const RowColumn          = styled.div`
    background-color: transparent;
    width: ${({Width}) => (
        typeof Width === 'number' && Width >= 0 && Width <=100 ?
        `${Width}%`:'100%'
    )};

    //display: flex;
    //align-items: center;
    //justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: ${({IsContainer}) => (
       !IsContainer?
       'unset':'center'
    )};
    border: ${({UseBorder}) => (
       UseBorder?
       'solid 0.5px #ccc;':'unset'
    )};
    border-radius: ${({UseBorder}) => (
       UseBorder?
       '10px':'unset'
    )};

    padding-bottom: ${({IsContainer}) => (
       !IsContainer?
       'unset':'5px'
    )};
    overflow: hidden;

    @media only screen and (max-width: ${(DefaultMaxScreenSize)}) {
        width: 99%;
        transition: 0.3s ease-in-out;
    }
`;

export const RowInputColumn     = styled.div`
    //display: flexbox;
    display: ${({IsMultiRow}) => (
       !IsMultiRow?
       'flex':'inline-flex'
    )};   
    flex-direction: column;

    //justify-content: space-between;
    justify-content: ${({IsMultiRow}) => (
       IsMultiRow?
       'flex-start':'space-between'
    )};
    width: ${({IsSplit}) => (
        IsSplit?
        '49.5%'
        :'100%'
    )};
    background-color: transparent;
    //align-items: center;    
    align-items: ${({IsCentered}) => (
       IsCentered?
       'center':undefined
    )};   
    
    @media only screen and (max-width: ${(DefaultMaxScreenSize)}) {
        display: flex;
        width: 100%;
        margin-bottom: 1mm;
        &:last-child {
            margin-bottom: unset;
        }
        transition: 0.3s ease-in-out;
    }
`;

export const RowButton          = styled.div`
    margin-top: ${({MarginTop}) => (
        typeof MarginTop === 'number' && MarginTop > 0?
        `${MarginTop}px`: '5px'
    )};
    /* width: 100%; */
    width: ${({Width}) => (
        typeof Width === 'number' && Width > 0?
        `${Width}%`: DefaultInputWidth
    )};
    display: inline-flex;
    flex-direction: row;

    //justify-content: space-between;
    justify-content: ${({Align}) => (
       typeof Align === 'string' && `${Align}`.trim().toLowerCase() === 'left'?
       'flex-start'
       :typeof Align === 'string' && `${Align}`.trim().toLowerCase() === 'right'?
       'flex-end'
       :typeof Align === 'string' && `${Align}`.trim().toLowerCase() === 'center'?
       'center'
       :'space-between'
    )};
`;

export const InputGroup         = styled.div`
    background-color: transparent;
    margin-top: ${({MarginTop}) => (
        typeof MarginTop === 'number' && MarginTop > 0?
        `${MarginTop}px`: 'unset'
    )};

    width: ${({Width}) => (
        typeof Width === 'number' && Width > 0?
        `${Width}%`: DefaultInputWidth
    )};

    display: inline-flex;
    //justify-content: space-between;
    justify-content: ${({IsNotJustify}) => (
        IsNotJustify?
        'flex-start': 'space-between'
    )};
    
    @media only screen and (max-width: ${(DefaultMaxScreenSize)}) {
        width: 100%;
        transition: 0.3s ease-in-out;
    }
`;
// =======================================================
// BUTTON
// =======================================================
export const ButtonContainer= styled.div`
    background-color: transparent;
    width: ${({Width}) => (
        typeof Width === 'number' && Width > 0?
        `${Width}%`: DefaultInputWidth
    )};
    display: flex;
    align-items: center;

    justify-content: ${({Align}) => (
       typeof Align === 'string' && `${Align}`.trim().toLowerCase() === 'left'?
       'left'
       :typeof Align === 'string' && `${Align}`.trim().toLowerCase() === 'right'?
       'right'
       :typeof Align === 'string' && `${Align}`.trim().toLowerCase() === 'center'?
       'center'
       :'center'
    )};
`;


export const ButtonFileReader   = styled.div`
    cursor: pointer;

    display: flex;
    flex-direction: row;
    align-items: center;
    justify-items: center;    
    justify-content: center;

    border-radius: 4px;
    //padding: 6px 9px;
    padding: ${({IsNoPadding}) => (
        IsNoPadding?
        `unset`:'6px 9px'
    )};
    opacity: unset;

    box-shadow: ${({Embossed, Mode}) => (
        Embossed?
        '3px 3px ' + handleButtonModeBoxShadow(Mode) :'none'
    )};

    border: none;    
    
    min-width: ${({MinWidth}) => (
        typeof MinWidth === 'string' && MinWidth.trim() !== ''?
        MinWidth:'90px'
    )};
    
    width: ${({Width}) => (
        typeof Width === 'number' && Width > 0?
        `${Width}px`:'max-content'
    )};   
    
    height: ${({Height}) => (
        typeof Height === 'number' && Height > 0?
        `${Height}px`:'max-content'
    )};

    background-color: ${({ Mode }) => handleButtonModeBgColor(Mode)};
    //background-color: pink;
    color: ${({Mode}) => (
        typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
        `${ButtonBgColorMode.primary}`:'#FFFFFF'
    )};

    &:hover {
        background-color: ${({ Mode }) => handleButtonModeBgHover(Mode)};
        color: #FFFFFF;        
        box-shadow: ${({Embossed, BackLightOnHover}) => (
            typeof Embossed === 'boolean' && Embossed && !BackLightOnHover?
            `3px 3px lightgrey;`:'none'
        )};

        box-shadow: ${({BackLightOnHover, Mode}) => (
            typeof BackLightOnHover === 'boolean' && BackLightOnHover?
                typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
                'none'
                :`${Mode}`.trim().toLowerCase() === 'primary'?
                `0px 4px 20px -2px ${ButtonBgColorMode.primary}`
                :`${Mode}`.trim().toLowerCase() === 'success'?
                `0px 4px 20px -2px ${ButtonBgColorMode.success}`
                :`${Mode}`.trim().toLowerCase() === 'warning'?
                `0px 4px 20px -2px ${ButtonBgColorMode.warning}`
                :`${Mode}`.trim().toLowerCase() === 'danger'?
                `0px 4px 20px -2px ${ButtonBgColorMode.danger}`
                :`${Mode}`.trim().toLowerCase() === 'active'?
                `0px 4px 20px -2px ${ButtonBgColorMode.active}`
                :`${Mode}`.trim().toLowerCase() === 'inactive'?
                `0px 4px 20px -2px ${ButtonBgColorMode.inactive}`
                :'none'
            :'none'
        )};
    }

    &:focus {
        background-color: ${({ Mode }) => handleButtonModeBgHover(Mode)};
        /*color: ${({ Mode }) => handleButtonModeText(Mode)};*/
        color: #FFFFFF;
        
        box-shadow: ${({Embossed, BackLightOnHover}) => (
            typeof Embossed === 'boolean' && Embossed && !BackLightOnHover?
            `3px 3px lightgrey;`:'none'
        )};

        box-shadow: ${({BackLightOnHover, Mode}) => (
            typeof BackLightOnHover === 'boolean' && BackLightOnHover?
                typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
                'none'
                :`${Mode}`.trim().toLowerCase() === 'primary'?
                `0px 4px 20px -2px ${ButtonBgColorMode.primary}`
                :`${Mode}`.trim().toLowerCase() === 'success'?
                `0px 4px 20px -2px ${ButtonBgColorMode.success}`
                :`${Mode}`.trim().toLowerCase() === 'warning'?
                `0px 4px 20px -2px ${ButtonBgColorMode.warning}`
                :`${Mode}`.trim().toLowerCase() === 'danger'?
                `0px 4px 20px -2px ${ButtonBgColorMode.danger}`
                :`${Mode}`.trim().toLowerCase() === 'active'?
                `0px 4px 20px -2px ${ButtonBgColorMode.active}`
                :`${Mode}`.trim().toLowerCase() === 'inactive'?
                `0px 4px 20px -2px ${ButtonBgColorMode.inactive}`
                :'none'
            :'none'
        )};
    }
`;

export const Button             = styled.button.attrs(({ IsSubmitButton }) => ({
    type:  IsSubmitButton? 'submit':'button'
  }))`
    margin: ${({IsMarginAuto}) => (
        IsMarginAuto?
        'auto':'unset'
    )};
    
    cursor: pointer;
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;

    border-radius: 4px;
    //padding: 6px 9px;
    padding: ${({FitSize}) => (
        FitSize?
        '5px 9px':'6px 9px'
    )};
    opacity: unset;

    //box-shadow: none;
    box-shadow: ${({Embossed, Mode}) => (
        Embossed?
        '3px 3px ' + handleButtonModeBoxShadow(Mode) :'none'
        //`3px 3px darkgrey;`:'none'
    )};
    /* box-shadow: ${({ Color }) => handleButtonModeBoxShadow(Color)};*/

    border: none;    
    //min-width: 90px;
    min-width: ${({MinWidth, FitSize}) => (
        FitSize?
        'fit-content'
        :typeof MinWidth === 'string' && MinWidth.trim() !== ''?
        MinWidth:'90px'
    )};
    width: ${({Width, FitSize}) => (
        FitSize?
        'fit-content'
        :typeof Width === 'number' && Width > 0?
        `${Width}px`:'max-content'
    )};

    height: ${({Height}) => (
        typeof Height === 'number' && Height > 0?
        `${Height}px`:'max-content'
    )};

    background-color: ${({ Mode }) => handleButtonModeBgColor(Mode)};
    //color: #FFFFFF;
    color: ${({Mode}) => (
        typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
        `${ButtonBgColorMode.primary}`:'#FFFFFF'
    )};

    margin-left: ${({MarginLeft}) => (
        typeof MarginLeft === 'number' && MarginLeft > 0?
        `${MarginLeft}px`:'unset'
    )};

    margin-right: ${({MarginRight}) => (
        typeof MarginRight === 'number' && MarginRight > 0?
        `${MarginRight}px`:'unset'
    )};

    &:hover {
        background-color: ${({ Mode }) => handleButtonModeBgHover(Mode)};
        /*color: ${({ Mode }) => handleButtonModeText(Mode)};*/
        color: #FFFFFF;        
        box-shadow: ${({Embossed, BackLightOnHover}) => (
            typeof Embossed === 'boolean' && Embossed && !BackLightOnHover?
            `3px 3px lightgrey;`:'none'
        )};

        box-shadow: ${({BackLightOnHover, Mode}) => (
            typeof BackLightOnHover === 'boolean' && BackLightOnHover?
                typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
                'none'
                :`${Mode}`.trim().toLowerCase() === 'primary'?
                `0px 4px 20px -2px ${ButtonBgColorMode.primary}`
                :`${Mode}`.trim().toLowerCase() === 'success'?
                `0px 4px 20px -2px ${ButtonBgColorMode.success}`
                :`${Mode}`.trim().toLowerCase() === 'warning'?
                `0px 4px 20px -2px ${ButtonBgColorMode.warning}`
                :`${Mode}`.trim().toLowerCase() === 'danger'?
                `0px 4px 20px -2px ${ButtonBgColorMode.danger}`
                :`${Mode}`.trim().toLowerCase() === 'active'?
                `0px 4px 20px -2px ${ButtonBgColorMode.active}`
                :`${Mode}`.trim().toLowerCase() === 'inactive'?
                `0px 4px 20px -2px ${ButtonBgColorMode.inactive}`
                :'none'
            :'none'
        )};
    }

    &:focus {
        background-color: ${({ Mode }) => handleButtonModeBgHover(Mode)};
        /*color: ${({ Mode }) => handleButtonModeText(Mode)};*/
        color: #FFFFFF;
        
        box-shadow: ${({Embossed, BackLightOnHover}) => (
            typeof Embossed === 'boolean' && Embossed && !BackLightOnHover?
            `3px 3px lightgrey;`:'none'
        )};

        box-shadow: ${({BackLightOnHover, Mode}) => (
            typeof BackLightOnHover === 'boolean' && BackLightOnHover?
                typeof Mode === 'undefined' || `${Mode}`.trim() === ''?
                'none'
                :`${Mode}`.trim().toLowerCase() === 'primary'?
                `0px 4px 20px -2px ${ButtonBgColorMode.primary}`
                :`${Mode}`.trim().toLowerCase() === 'success'?
                `0px 4px 20px -2px ${ButtonBgColorMode.success}`
                :`${Mode}`.trim().toLowerCase() === 'warning'?
                `0px 4px 20px -2px ${ButtonBgColorMode.warning}`
                :`${Mode}`.trim().toLowerCase() === 'danger'?
                `0px 4px 20px -2px ${ButtonBgColorMode.danger}`
                :`${Mode}`.trim().toLowerCase() === 'active'?
                `0px 4px 20px -2px ${ButtonBgColorMode.active}`
                :`${Mode}`.trim().toLowerCase() === 'inactive'?
                `0px 4px 20px -2px ${ButtonBgColorMode.inactive}`
                :'none'
            :'none'
        )};
    }
`;

    export const ButtonIcon     = styled.div`
        display: flex;
        align-items: center;
        justify-items: center;
    `;
    export const ButtonLabel    = styled.div`
        font-size: ${({FontSize}) => (
            typeof FontSize === 'undefined' || `${FontSize}`.trim() === '' ?
            DefaultInputFontSize:`${FontSize}`
        )};
        font-weight: ${({IsBold}) => (
            IsBold?
            'bold':'normal'
        )};            
        text-transform: ${({IsUpperCase}) => (
            !IsUpperCase?
            'normal':'uppercase'
        )};
        font-style: ${({IsItalic}) => (
            IsItalic?
            'italic':'normal'
        )};

        background-color: transparent;

        display: flex;
        align-items: center;
        justify-items: center;
    `;
// =======================================================
// LOGO
// =======================================================
export const InputLogoContainer         = styled.div`
    width: ${({Width}) => (
        typeof Width === 'number' && Width >= 0 && Width <= 100?
        `${Width}%`: DefaultInputBoxWidth
    )};
    margin: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    
    border: 0.5px solid ${(DefaultInputBorderColor)};
    border-radius: 2px;
    box-sizing: border-box;
    box-shadow: ${({IsBoxed}) => (
        IsBoxed?
        '0px 2px 2px #CCCCCC':'unset'
    )};
    padding-top: 2px;
    padding-bottom: 2px;

    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        width: 100%;
        transition: 0.3s ease-in-out;
    }
`;
export const InputLogoFrame             = styled.div`
    width: 98%;
    height: 75px;

    background-color: white;
    margin-top: 5px;
    margin-bottom: 5px;

    margin-left: auto;
    margin-right: auto;

    overflow: hidden;

    border: 0.5px solid ${(DefaultInputBorderColor)};
    border-radius: 4px;
`;
export const InputLogo                  = styled.img`
    width: 340px;    
    height: 70px;
    background-color:transparent;
      
    display: block;
    margin-left: auto;
    margin-right: auto;
    overflow: hidden;
    opacity: unset;
    margin-top: 3px;

    box-sizing: border-box;
    box-shadow: unset;
    outline: none;

    font-size: ${(DefaultInputFontSize)};
    color: lightgrey;
    //border: solid 0.3px lightgrey;
`;

// =======================================================
// CUSTOM HISTORY
// =======================================================
export const BoxHistoryContainer        = styled.div`
    background-color: transparent;
    /*
    border-bottom: ${({NoBorderBottom}) => (
        NoBorderBottom?
        undefined:'solid 0.5px lightgrey'
    )};
    */
    border-bottom: ${({NoBorderBottom}) => (
        NoBorderBottom?
        undefined:'solid 0.5px #002b70'
    )};  
    padding-top: 3px;
    padding-bottom: 3px;
    
    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    overflow:hidden;

    &:last-child {
        border-bottom: ${({NoBorderBottom}) => (
            NoBorderBottom?
            undefined:'none'
        )}; 
    }
`;
export const BoxHistory                 = styled.div`
    background-color: transparent;
    display: flex;
    flex-direction: column;
    //padding-left: 3px;

    overflow: hidden;
    width: ${({Width}) => (
        typeof Width === 'number' && Width >= 1 && Width <= 100?
        `${Width}%`: '99%'
    )};

    border: ${({IsBoxed}) => (
        IsBoxed?
        'solid 0.5px #002b70':undefined
    )}; 
    border-radius: ${({IsBoxed}) => (
        IsBoxed?
        '3px':undefined
    )}; 
    padding-left: ${({IsBoxed}) => (
        IsBoxed?
        '3px':undefined
    )}; 
    padding-right: ${({IsBoxed}) => (
        IsBoxed?
        '3px':undefined
    )}; 
`;
export const HistoryHeader              = styled.div`
    padding-top: 4px;
    //padding-left: 5px;
    //padding-left: 5px;
    padding-bottom: 4px;

    background-color: transparent;
    
    display: flex;
    flex-direction: row;
    //align-items: center;
    align-items: flex-start;
    justify-content: space-between;    

    border-bottom: ${({BorderBottom}) => (
        BorderBottom?
        'solid 0.5px lightgrey':undefined
    )}; 
`;
export const HistoryHeaderDetail        = styled.div`
    display: flex;
    flex-direction: column;
    
    background-color: transparent;
    //width: max-content;
    width: ${({Width}) => (
        typeof Width === 'number' && Width > 0 && Width <= 100?
        `${Width}%`: 'max-content'
    )};
    @media screen and (max-width: ${(DefaultMaxScreenSize)}) {
        width: 90%;
    }
`;
    export const HistoryHeaderData      = styled.div`
        width: ${({Width}) => (
            typeof Width === 'number' && Width >= 1 && Width <= 100?
            `${Width}%`: 'max-content' //'82%'
        )};
        font-weight: ${({IsBold}) => (
            IsBold?
            'bold':'normal'
        )}; 
        text-transform: ${({IsUpperCase}) => (
            IsUpperCase?
            'uppercase':'normal'
        )}; 
        font-style: ${({IsItalic}) => (
            IsItalic?
            'italic':'normal'
        )}; 
        font-size: ${({FontSize, IsTextArea}) => (
            !IsTextArea?
            typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
            DefaultTableTextValueSize:`${FontSize}`
            :
            typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
            DefaultTablBodyFontSize:`${FontSize}`
        )};

        color: ${({ Color }) => HandleTextColorMode(Color)};
        text-align: left;
        display: block;
    `;


export const HistoryBody                = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: ${({MarginTop}) => (
        typeof MarginTop === 'number' && MarginTop > 0?
        `${MarginTop}px`: '4px'
    )};

    //padding-left: 5px;
    padding-bottom: 3px;
`;
export const HistoryBodyData            = styled.div`
    width: ${({Width}) => (
        typeof Width === 'number' && Width >= 1 && Width <= 100?
        `${Width}%`: 'max-content' //'82%'
    )};
    font-weight: ${({IsBold}) => (
        IsBold?
        'bold':'normal'
    )}; 
    text-transform: ${({IsUpperCase}) => (
        IsUpperCase?
        'uppercase':'normal'
    )}; 
    font-style: ${({IsItalic}) => (
        IsItalic?
        'italic':'normal'
    )}; 
    margin-top: ${({MarginTop}) => (
        typeof MarginTop === 'number' && MarginTop > 0?
        `${MarginTop}px`: undefined
    )};
    font-size: ${({FontSize, IsTextArea}) => (
        !IsTextArea?
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        DefaultTableTextValueSize:`${FontSize}`
        :
        typeof FontSize !== 'string' || `${FontSize}`.trim() === ''?
        DefaultTablBodyFontSize:`${FontSize}`
    )};

    color: ${({ Color }) => HandleTextColorMode(Color)};
    text-align: left;
    display: block;
        
    white-space: ${({IsTextArea}) => (
        IsTextArea?
        'pre':'unset'
    )};

    overflow: ${({IsTextArea}) => (
        IsTextArea?
        'auto':'unset'
    )};
    cursor: ${({IsLink}) => (
        IsLink?
        'pointer':'default'
    )};
    &:hover {
        text-decoration: ${({IsLink}) => (
            IsLink?
            'underline':'undefined'
        )}; 
    }
`;

// =======================================================
// TAMBAHAN LIST
// =======================================================

